import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleNavigation from '../../../../components/layout/docs/ArticleNavigation';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import '../getting-started/HelpCategoryPage.css';

/**
 * Your Profile Article Page
 */
const YourProfile = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <div className="article-content">
              <header className="article-header">
                <h1 className="article-title">Your Profile</h1>
                <p className="article-subtitle">
                  Your WeSplit profile is your identity on the network. Learn how to customize it, manage your public visibility, and interact with other users' profiles.
                </p>
              </header>

              <div className="article-separator"></div>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Overview</h2>
                  <p className="article-section-intro">
                    Your profile acts as your <strong>social proof</strong> within the WeSplit ecosystem. It is visible to anyone on the app, allowing friends and merchants to verify your identity before transacting. A complete and active profile builds trust and makes splitting expenses easier.
                  </p>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Navigating Profiles</h2>
                  <h3 className="article-subsection-title">Accessing a Profile</h3>
                  <p className="article-section-intro">
                    You can view another user's profile by selecting them from your contact list or tapping on their name in any group or transaction log.
                  </p>
                </div>

                <div className="article-subsection">
                  <h3 className="article-subsection-title">What You Can See & Do</h3>
                  <p className="article-section-intro">
                    When visiting a user's profile, you have access to:
                  </p>
                  <ul className="article-list-dots">
                    <li>
                      <strong>Quick Actions:</strong> Instantly <strong>Send</strong> or <strong>Request</strong> money using the shortcut buttons.
                    </li>
                    <li>
                      <strong>Public Info:</strong> View their username (pseudo), profile picture, and displayed badges.
                    </li>
                    <li>
                      <strong>Activity History:</strong> If you have shared expenses in the past, a history of your mutual interactions is displayed here.
                    </li>
                    <li>
                      <strong>Favorites:</strong> Tap the star icon to add them to your favorites for quicker access later.
                    </li>
                  </ul>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Customizing Your Look</h2>
                  <p className="article-section-intro">
                    You have full control over how you appear to others. Go to <strong>Settings &gt; Profile</strong> to edit the following:
                  </p>
                </div>

                <div className="article-subsection">
                  <h3 className="article-subsection-title">1. Identity</h3>
                  <ul className="article-list-dots">
                    <li>
                      <strong>Pseudo:</strong> Choose a unique username that makes you easily recognizable to friends.
                    </li>
                    <li>
                      <strong>Profile Picture:</strong> Upload a photo or avatar to stand out in lists and groups.
                    </li>
                  </ul>
                </div>

                <div className="article-subsection">
                  <h3 className="article-subsection-title">2. Badges & Reputation</h3>
                  <p className="article-section-intro">
                    Showcase your achievements and community standing.
                  </p>
                  <ul className="article-list-dots">
                    <li>
                      <strong>Reward Badges:</strong> You can choose to <strong>show</strong> or <strong>hide</strong> the achievement badges you have earned through app usage.
                    </li>
                    <li>
                      <strong>Community Badge:</strong> If you belong to multiple communities (e.g., "Early Adopter," "Beta Tester"), select the specific Community Badge you want to display next to your name on your public profile via the Profile Settings.
                    </li>
                  </ul>
                </div>
              </section>

              <div className="article-separator"></div>

              <LastUpdated />

              <ArticleNavigation
                previous={{
                  title: 'Link Cards & Wallets',
                  route: getHelpRoute(getHelpArticleRoute('features', 'link-cards-wallets'))
                }}
                next={{
                  title: 'Badge Community',
                  route: getHelpRoute(getHelpArticleRoute('features', 'badge-community'))
                }}
              />
            </div>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default YourProfile;
